module.exports = __webpack_public_path__ + "img/add-patient_1x.ab2723ad.png";